<template>
  <div class="AppFileUploadFilder">
    <AppTooltip>
      <template #activator="{props}">
        <div class="AppFileUploadFilder__name"
             v-bind="props"
        >
          <slot name="filderName"></slot>
          <ClosdFildersIcon class="mr-2" :document="filder.fileObject || filder" size="22" small/>
          <span class="text--bold">{{ filderName }}</span>
        </div>
      </template>
      <span>{{ filderName }}</span>
    </AppTooltip>
    <div class="AppFileUploadFilder__action">
      <div v-if="filderStatus === uploadStatus.PENDING || filderStatus === uploadStatus.IN_PROGRESS"
           @mouseenter="progressHover = true"
           @mouseleave="progressHover = false"
      >
        <template v-if="progressHover">
          <AppTooltip>
            <template #activator="{props}">
              <AppButton icon
                         v-bind="props"
                         @click="onCancelClick"
              >
                <app-material-icon name="close"
                                   class="text-body-1"
                />
              </AppButton>
            </template>
            <span>{{ $t('common.cancel') }}</span>
          </AppTooltip>
        </template>
        <template v-else>
          <v-progress-circular :model-value="filderProgress"
                               color="info"
                               size="30"
                               width="3"
          >
          </v-progress-circular>
        </template>
      </div>
      <app-material-icon v-if="filderStatus === uploadStatus.SUCCESS"
                         name="check"
                         color="success"
      />
      <div v-if="filderStatus === uploadStatus.CANCELED"
           class="text-caption font-weight-semi-bold text-originalGrey"
      >
        {{ $t('common.app-file-upload.AppFileUploadFilder.canceledImport') }}
      </div>
      <template v-if="filderStatus === uploadStatus.ERROR">
        <div v-if="filderError">
          {{ filderError }}
        </div>
        <AppButton v-else
                   icon
                   @click="redoFilder"
        >
          <app-material-icon name="redo"
                             color="error"
          />
        </AppButton>
      </template>
    </div>
  </div>
</template>

<script>
import AppTooltip from '@/common/AppTooltip.vue'
import AppButton from '@/common/buttons/AppButton.vue'
import ClosdFildersIcon from '@/common/filders/ClosdFildersIcon.vue'

import { uploadStatus } from './uploadStatus'

export default {
  name: 'AppFileUploadFilder',
  components: { AppButton, AppTooltip, ClosdFildersIcon },
  props: {
    filder: {
      type: Object,
      required: true,
    },
    filderName: {
      type: String,
      required: true,
    },
    filderProgress: {
      type: Number,
      required: true,
    },
    filderStatus: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      uploadStatus,
      progressHover: false,
    }
  },
  computed: {
    filderError () {
      if (this.filder.error) {
        if (this.filder.error === 'ERR_WRONG_FILE_TYPE' || this.filder.error === 'ERR_FILE_TOO_LARGE') {
          return this.$t(`common.app-file-upload.AppFileUploadFilder.error.${this.filder.error}`)
        }
      }
      return null
    },
  },
  methods: {
    onCancelClick () {
      this.filderStatus === this.uploadStatus.PENDING ? this.cancelPendingFilder() : this.cancelInProgressFilder()
    },
    cancelPendingFilder () {
      this.$emit('cancelPendingFilder')
    },
    cancelInProgressFilder () {
      this.$emit('cancelInProgressFilder')
    },
    redoFilder () {
      this.$emit('redoFilder')
    },
  },
}
</script>

<style scoped lang="scss">
.AppFileUploadFilder {
  display: grid;
  grid-template-columns: minmax(30%, 100%) auto;
  align-items: center;
  border-bottom: 1px solid rgb(var(--v-theme-originalGrey-lighten-2));
  column-gap: 10px;
  margin-bottom: 5px;
  min-height: 40px;

  &__name {
    max-width: 70%;
    display: flex;
    align-items: center;
    & span {
      overflow-x: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
</style>
